import m001 from './001-initial-state'
import m002 from './002-remove-key-metric'
import m003 from './003-clear-projects-data'
import m004 from './004-clear-non-context-storage'
import m005 from './005-drop-projects'

export default {
    available: [ m001, m002, m003, m004, m005 ],
}
